export default {
  namespaced: true,
  state: {
    load: '',
    cpu: '',
    memory: '',
    usage: '',
    swap: '',
    disks: '',
    nets: ''
  },
  mutations: {
    set: (state, content) => {
      state.load = content.loadaverage
      state.cpu = content.cpu
      state.memory = content.memory
      state.usage = content.usage
      state.swap = content.swap
      state.disks = content.disk
      state.nets = content.net
    }
  },
  getters: {
    load: (state) => state.load,
    cpu: (state) => state.cpu,
    memory: (state) => state.memory,
    usage: (state) => state.usage,
    swap: (state) => state.swap,
    disks: (state) => state.disks,
    nets: (state) => state.nets
  }
}
